import React, { FC } from 'react';
import { ResourceLoader, ResourceLoaderProps } from 'ia-react-core';
import transformParameters from './transformParameters/transformParameters';
import getApiRoot from '../../utils/getApiRoot';
import { ParametersDto } from '../../interfaces/dtos/ParametersDto';
import { Parameters } from '../../interfaces/Parameters';

export interface ParametersLoaderProps extends ResourceLoaderProps<Parameters> { }

const ParametersLoader: FC<ParametersLoaderProps> = (props) => (
  <ResourceLoader
    name="parametersResource"
    url={`${getApiRoot()}/settings/parameters`}
    dataDst="/App.features.securedMessaging.parameters"
    transformResponse={({ data }: { data: ParametersDto }) => transformParameters(data)}
    {...props}
  />
);

export default ParametersLoader;
